export default "__VITE_ASSET__BIOub9FU__"